import { observer } from 'mobx-react-lite';
import { Redirect, useParams } from 'react-router-dom';
import { Spinner } from 'src/components/Spinner/Spinner';
import { SettingsScoringModelStore as store } from 'src/stores/SettingsStores/SettingsScoringModelStore/SettingsScoringModelStore';

type Props = { basePath: string };

export const ScoringModelRedirect = observer(({ basePath }: Props) => {
    const { entityId } = useParams<{ entityId?: string }>();
    const firstEntity = entityId ?? store.list?.[0]?.id;

    // Show spinner while loading
    if (store?.listOfModelVersions?.isLoading || store?.listLoader?.isLoading) {
        // console.log('scoring: loading');

        return <Spinner />;
    }

    // Don't redirect if versions aren't loaded yet or if there are no versions
    if (!store?.listVersions || store?.listVersions?.length === 0) {
        // console.log('scoring: no versions');

        return <Spinner />;
    }

    // Find the ACTIVE version, fallback to first version if no active version exists
    const activeVersion = store?.listVersions?.find(
        (version) => version.status === 'ACTIVE',
    );
    const versionToRedirect = activeVersion?.id || store?.listVersions?.[0]?.id;

    // Additional safety check to ensure we have a valid version ID
    if (!versionToRedirect) {
        // console.log('scoring: no version to redirect');

        return <Spinner />;
    }

    return (
        <Redirect
            to={`${basePath}/${firstEntity}/versions/${versionToRedirect}`}
        />
    );
});
